
import type { FC } from 'react';
import { memo} from 'react';

import classNames from 'classnames';
import { useDrop } from 'react-dnd';
import { useDragAndDrop } from '@/utils/useDragAndDrop';
import { IDragQuestionProps } from '@/utils/ctype';
import Drag from '../../../components/Drag';
import Drop from '../../../components/Drop';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';


// 2



const Container: FC<IDragQuestionProps> = memo(function Container(props) {
  
  const { data , saveAnswerHandle, pageData, loadAnswered, answerMap, keyIndex, setShowDragFieldHandle, setFocusIndexHandle} = props;
  const { collect_option, question_title, list} = data || {};

  
  const {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList
  } = useDragAndDrop(data, {optionHidden: 'show', type: 'dependentPairingTitle', accepts: ['dependentPairingTitle', 'dependentPairingBlank'], blankType: 'dependentPairingBlank', saveAnswerHandle, pageData, loadAnswered, answerMap});

  // const [{ isOver, canDrop }, drop] = useDrop({
  //   accept: ['dependentPairingBlank'],
  //   drop: () => {},
  //   collect: (monitor) => ({
  //     isOver: monitor.isOver(),
  //     canDrop: monitor.canDrop(),
  //   }),
  // });
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['dependentPairingTitle', 'dependentPairingBlank'],
    drop: handleDropOptionList,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  return (
    <div className={style.box}>
      <div className={style.question}>
        <div data-exam-neutral-text data-exam-text-size="18" className={style.questionTitle} data-key={`question.question.${keyIndex}.question_title`}><HtmlParser htmlString={question_title}></HtmlParser></div>
        {dustbins.map(({ accepts, lastDroppedItem, data, type, uid }, index) => (
          <div data-exam-text-size="18" className={style.questionItem} key={index}>
            <Drop
              type={type}
              accept={accepts}
              lastDroppedItem={lastDroppedItem}
              onDrop={(item) => handleDrop(index, item)}
              index={index}
              data={data}
              recoverOption={recoverOption}
              recoverBlank={() => recoverBlank(index)}
              id={`question${data.number}`}
              uid={uid}
              onFocus={() => setFocusIndexHandle && setFocusIndexHandle(data.number)}
            />
            <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${index}.title`}>
              <HtmlParser htmlString={list[index].title}></HtmlParser></span>
          </div>
          
        ))}
      </div>

      <div className={style.answer}>
        <div data-exam-text-size="18" className={style.optionTitle} data-key={`question.question.${keyIndex}.collect_option.title`}><HtmlParser htmlString={collect_option.title}></HtmlParser></div>
        {/* , isOver && canDrop ? style.hover : '' */}
        <div data-exam-surface data-exam-drop-hover={isOver} className={classNames(style.answerList, isOver ? style.isOver : '')} ref={drop}>
          {boxes.map(({ data, type, display, optionHidden, uid}, index) => (
            <Drag data={data} type={type} key={index} index={index} optionClass={style.mt15} display={display}
              optionHidden={optionHidden} uid={uid} setShowDragFieldHandle={setShowDragFieldHandle}/>
          ))}
        </div>
        
      </div>
    </div>
  );
});

export default Container;
